export default [
  {
    path: '/halal-shipment',
    name: 'halal-shipment',
    component: () => import('@/views/halal/shipment/Shipment.vue'),
    meta: {
      title: 'Kuwait Halal Shipment',
      requiresAuth: true,
      action: 'browes',
      resource: 'Halal Shipment',
      pageTitle: 'Kuwait Halal Shipment',
      breadcrumb: [
        {
          text: 'Kuwait Halal Shipment',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
